import CollectionSponsorBank from "../../../../component/systemMaster/sponsorBank/collectionSponsorBank/collectionSponsorBank"

const CollectionSponsorBanks=()=>{
    return <CollectionSponsorBank/>
}
export default CollectionSponsorBanks;